import React from 'react';
import { Navbar } from "react-bootstrap";
import social_discord from '../../../images/social-discord.png'
import social_reddit from '../../../images/social-reddit.png'
import social_medium from '../../../images/social-medium.png'
import social_fb from '../../../images/social-fb.png'
import social_tw from '../../../images/social-tw.png'

export default () =>
    (<Navbar className="social-footer-wrapper">
        <div className="footer social-footer">
            <a href='https://discord.gg/ehUJhkR' rel='noopener noreferrer' key='1' target="_blank">
                <img src={social_discord} alt=""/>
            </a>
            <a href='https://reddit.com/r/cryptoassault' rel='noopener noreferrer' key='2' target="_blank">
                <img src={social_reddit} alt=""/>
            </a>
            <a href='https://medium.com/cryptoassault' rel='noopener noreferrer' key='3' target="_blank">
                <img src={social_medium} alt=""/>
            </a>
            <a href='https://www.facebook.com/cryptoassault' rel='noopener noreferrer' key='4' target="_blank">
                <img src={social_fb} alt=""/>
            </a>
            <a href='https://twitter.com/crypto_assault' rel='noopener noreferrer' key='5' target="_blank">
                <img src={social_tw} alt=""/>
            </a>
        </div>
    </Navbar>);
